import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH } from '../types/shared';
import { getRequestBaseParams } from '../utils/request';
const TASK_COMPLETE_STATUS = 0;
const TASK_RISK_STATUS = 405;
const SAME_USER_ID_NOT_ALLOWED = 10079;
const DEFAULT_TOAST = '助力失败，请稍后重试';
export function useAssistAction(options) {
    const ctx = useMonitorEngineContext();
    const { leaderId } = ctx._runtimeInfo?.queryParams || {};
    const commonParams = ctx._runtimeInfo?.commonParams ?? {};
    const { request: taskComplete } = useRequest(API_PATH.TASK_COMPLETE, {
        method: 'POST',
        showLoading: true,
        raw: true
    });
    async function onTriggerAssistAction() {
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const params = {
                ...feCommonParams,
                activityId: options.activityId,
                taskId: options.taskId,
                followerId: feCommonParams.userId.toString(),
                leaderId
            };
            const rawRes = await taskComplete(params);
            const { status: resStatus, data: resData, message } = rawRes;
            const { leaderRewards } = resData ?? {};
            if (resStatus === TASK_COMPLETE_STATUS) {
                if (Array.isArray(leaderRewards) && leaderRewards.length === 0) {
                    ctx._uiInteractionAPI.toast.show({
                        content: options.feConfig?.emptyRewardToast || DEFAULT_TOAST
                    });
                    return false;
                }
                return true;
            }
            else if (resStatus === TASK_RISK_STATUS) {
                ctx._uiInteractionAPI.toast.show({
                    content: options.feConfig?.riskToast || DEFAULT_TOAST
                });
                return false;
            }
            else if (resStatus === SAME_USER_ID_NOT_ALLOWED) {
                ctx._uiInteractionAPI.toast.show({
                    content: '不能给自己助力哦～'
                });
                return false;
            }
            else {
                throw new Error('助力接口异常');
            }
        }
        catch (error) {
            ctx._uiInteractionAPI.toast.show({
                content: options.feConfig?.defaultToast || DEFAULT_TOAST
            });
            ctx._raptorReport.monitorReportBizFailed?.({
                apiPath: API_PATH.TASK_COMPLETE
            });
            ctx._raptorReport.monitorReportLog?.('assistAction', error, {
                level: 'error',
                category: 'ajaxError'
            });
            return false;
        }
    }
    return {
        onTriggerAssistAction
    };
}
